module.exports = __webpack_public_path__ + "static/media/protection.32539080.svg";